import AreaBudgetNavPanel from '../AreaBudgetNavPanel';

export default function SurveyBudgetNavPanel(props) {
  return <AreaBudgetNavPanel area="survey" {...props} />;
}
